<div
  class="search-col-overview-fields"
  [class.search-col-overview-fields--constrained]="constrainHeight"
  [class.search-col-overview-fields--show-more-visible]="showMoreButtonVisible"
>
  @if (searchObject && !hideHeadline) {
    <app-object-url
      class="list-overview-fields__headline"
      [object]="searchObject"
      [listName]="'overview'"
      [openLinksInTab]="openLinksInTab"
    >
      <div class="object-url-content">
        <i
          class="list-item-icon object-icon {{searchObject.$$icon}}"
          [class.text-blue]="searchObject.meta_type === MetaTypes.ADM_EVENT"
        ></i>

        <h2 class="bold list-overview-fields__headline-text text-link">
          {{searchObject.artifact_name}}
        </h2>
      </div>
    </app-object-url>
  }

  <div
    #fieldContentElement
    id="fieldContent"
    class="list-overview-fields__content content-selector-source__content search-col-overview-fields__content"
    [ngClass]="{'selector': viewName === 'selector', 'is-expanded': expandedSmallContent, 'has-collapsible-fields': hasCollapsibleFields}"
  >
    @for (field of visibleFields; track $index) {
      <div class="search-col-overview-fields__item {{field.container_class}}">
        <div class="list-overview-fields__field">
          <div class="list-overview-fields__field-title">
            <span>
              {{field.title}}:
            </span>
          </div>

          <div class="list-overview-fields__field-content">
            <app-overview-field
              [overviewField]="field"
              [viewName]="viewName"
              [disableLinks]="openLinksInTab"
              [toneDownTextColor]="true"
            ></app-overview-field>
          </div>
        </div>
      </div>
    }

    @if (hasCollapsibleFields) {
      <button
        (click)="toggleSmallContent($event)"
        class="search-col-overview-fields__show-more"
        [attr.aria-expanded]="expandedSmallContent"
        [attr.aria-controls]="'fieldContent'"
        mat-button
        type="button"
      >
        @if (expandedSmallContent) {
          <span class="search-col-overview-fields__show-more-text">
            {{ 'TRANS__OBJECT_CONTENT_LIST_SOURCE_ARRAY_ITEMS__SHOW_LESS' | translate }}
          </span>
        }
        @else {
          <span class="search-col-overview-fields__show-more-text">
            {{ 'TRANS__SEARCH_COL_OVERVIEW_FIELDS__SHOW_MORE_FIELDS' | translate }}
          </span>
        }
      </button>
    }
  </div>
</div>
